"use client";

import React from "react";
import Link from "next/link";
import { IntlLink } from "@/lib/utils/navigation";
import { trackMixpanelEvent } from "@/lib/utils/trackEvent";
import { MixpanelEvent, MixpanelEventDataMap } from "@/constant/mixpanelEvent";
interface TrackedLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  mixpanelEvent?: MixpanelEvent;
  mixpanelEventData?: MixpanelEventDataMap[keyof MixpanelEventDataMap];
  prefetch?: boolean;
  useIntlLink?: boolean; // 是否使用国际化链接
}

export default function TrackedLink({
  href,
  children,
  className,
  mixpanelEvent,
  mixpanelEventData,
  prefetch,
  useIntlLink = true,
}: TrackedLinkProps) {
  const handleClick = () => {
    if (mixpanelEvent) {
      trackMixpanelEvent(mixpanelEvent, mixpanelEventData);
    }
  };

  const LinkComponent = useIntlLink ? IntlLink : Link;

  return (
    <LinkComponent
      href={href}
      className={className}
      onClick={handleClick}
      prefetch={prefetch}
    >
      {children}
    </LinkComponent>
  );
}
